module.exports = __webpack_public_path__ + "res/27-img_o.a7e50e29bf9be966feb4a032174a2405.png";